<div class="vae-responsible-priest-filter__heading">
  <span>Pastor de hogar</span>
  <span *ngIf="selectedPastors.length" class="vae-responsible-priest-filter__count">{{ selectedPastors.length }} seleccionado{{ selectedPastors.length === 1 ? '' : 's' }}</span>
</div>
<mat-form-field class="vae-responsible-priest-filter__trigger" appearance="fill" subscriptSizing="dynamic">
  <input matInput readonly [value]="selectionLabel" placeholder="Seleccionar pastores..." [attr.aria-expanded]="panelOpen" aria-label="Pastor de hogar" (click)="togglePanel()">
  <button mat-icon-button matSuffix type="button" [attr.aria-label]="panelOpen ? 'Cerrar pastores de hogar' : 'Abrir pastores de hogar'" (click)="$event.stopPropagation(); togglePanel()">
    <span class="vae-responsible-priest-filter__select-arrow" [class.vae-responsible-priest-filter__select-arrow--open]="panelOpen"></span>
  </button>
</mat-form-field>

<section *ngIf="panelOpen" class="vae-responsible-priest-filter__panel">
  <mat-form-field appearance="fill" subscriptSizing="dynamic">
    <input matInput [formControl]="search" placeholder="Buscar por nombre..." aria-label="Buscar pastor de hogar por nombre">
  </mat-form-field>

  <div class="vae-responsible-priest-filter__results" *ngIf="filteredPastors.length; else noResults">
    <label class="vae-responsible-priest-filter__person" *ngFor="let pastor of filteredPastors">
      <mat-checkbox [checked]="isSelected(pastor.value)" (change)="toggle(pastor.value, $event.checked)" [attr.aria-label]="pastor.label ?? pastor.value"></mat-checkbox>
      <span class="vae-responsible-priest-filter__person-name">{{ pastor.label ?? pastor.value }}</span>
    </label>
  </div>
  <ng-template #noResults><p class="vae-responsible-priest-filter__empty">No se encontraron pastores de hogar.</p></ng-template>
</section>
